var DefaultAnalyticsAPI = /** @class */ (function () {
    function DefaultAnalyticsAPI() {
    }
    DefaultAnalyticsAPI.prototype.trigger = function (category, action, payload) {
        // Do nothing.
    };
    DefaultAnalyticsAPI.prototype.markAsSafe = function () {
        var allowedStrings = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            allowedStrings[_i] = arguments[_i];
        }
        // Do no filtering
        return function (value) {
            return value;
        };
    };
    DefaultAnalyticsAPI.prototype.dangerouslyCreateSafeString = function (value) {
        // Do nothing
        return value;
    };
    return DefaultAnalyticsAPI;
}());
export default new DefaultAnalyticsAPI();
//# sourceMappingURL=DefaultAnalyticsAPI.js.map